

<div class="panel panel--sm panel--wide">
  <div class="benefit-filter">
    <p class="benefit-filter__label"><span>{{items.length}}</span> Personal Items</p>
    <div class="central-filter__filter">
      <div class="dropdown dropdown--central dropdown--persist" id="benefitclaim-filter">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown" id="benefitclaim-filter-btn" aria-expanded="true">
          All
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="benefitclaim-filter-btn" x-placement="bottom-end" style="position: absolute; transform: translate3d(-121px, 14px, 0px); top: 0px; left: 0px; will-change: transform;">
          <div class="filter-list__heading">Filter between:</div>
          <ul class="filter-list filter-list--central list-unstyled" id="benefitclaim-filter-list">
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" checked="" value="all" name="benefitclaim-filter[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All Categories</span>
              </label>
            </li>
            @for (heading of getHeadings(); track heading) {
              <li>
                <label class="custom-input custom-input--radio">
                  <input type="radio" value="personal" name="benefitclaim-filter[]">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">{{heading}}</span>
                </label>
              </li>
            }
          </ul>
          <div class="filter-list__button">
            <button id="benefitclaim-filter-apply" class="button button--primary button--block">Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  @for (heading of getHeadings(); track heading) {
    <div class="form-group mb-30" id="multiselect-example">
      <div class="card-title__text">
        <svg class="icon icon--lg"><use xlink:href="#bicycle-outline"></use></svg>
        <p class="font-semibold">{{heading}}</p>
      </div>
      @for (item of getItems(heading); track item) {
        <label class="custom-input custom-input--checkbox custom-input--vehicle">
          <input type="checkbox" [checked]="item.checked" (click)="checkMultiSelect()" [value]="item.item_id" name="{{uniqueControlName}}">
          <span class="custom-input__indi"></span>
          <span class="custom-input__label">
            <h5 class="font-16">{{item.description}}</h5>
          </span>
        </label>
      }
    </div>
  }
</div>